const items = [5, 10, 15, 20, 25, 50, 100];
export default items;
